<div #htmlEditor style="height: 540px;"></div>
